/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/img-handle/img-handle');

const tip = require('components/base/pop/tip');
const { apiPath } = require('appService/api');
const ajaxHttp = require('appUtil/ajaxHttp');

require('./user-detail.scss');
const template = require('./user-detail.tpl');

const UserDetail = {
	name: "user-detail",

	template,

	data() {
		return {
			form: {},
			vertifyThItems: ["序号", "品牌", "型号", "车牌号", "车辆识别码", "发动机号", "状态", "提交时间","操作时间", "操作"],
			vertifyInfos: [],   //认证信息列表数据
			addressUrl: apiPath.user.queryAddress,
			addressThItem: ["序号", "收件人", "收货地址", "联系电话", ""],
			deviceDetail: '',
			verImgThItems: ["品牌", "型号", "车牌号", "车辆识别码", "发动机号", "订单RN号"],
			vertiImageInfo: '', //查看照片接口信息
			vertifyHead: '',    //取消认证、驳回pop头标题
			vertifyTip: '',     //取消认证、驳回pop输入提示
			vertifyIndex: '',   //认证信息列表index
			vertifyItem: '',    //通过、驳回、取消status，取消-3，通过1，驳回-2
			rejectReason: '',   //查看原因显示的驳回原因
			checkChangeTip: '', //checkbox点击弹出pop的确认提示信息
			checkboxValue: {},  //checkbox点击前后value
			vertifyState: {
      	"1": "已认证",
      	"-1": "待认证",
      	"-2": "已驳回"
      },
      sex: {
      	"0": "未知",
      	"1": "男",
      	"2": "女"
      },
			queryParams: {
				userId: this.$route.query.userId
			},
			qrCodeObj: {
				qrCls: 'qrcode',
        qrText: 'http://www.baidu.com'
			}
		}
	},

	ready() {
		this.queryUserDetail();
	},

	methods: {
		queryUserDetail() {
			let url = apiPath.user.userDetail;
			ajaxHttp(url, {
				"data": this.queryParams
			}).then((res) => {
				this.form = res.data;
				this.vertifyInfos = res.data.vertifyMessage;
				this.$refs.flagCheckbox && this.$refs.flagCheckbox.val(res.data.userFlag);
				this.$refs.flagCheckbox && this.$refs.forbitCheckbox.val(res.data.forbitDay);
				this.$refs.flagCheckbox && this.$refs.hideCheckbox.val(res.data.hideForumType)
			}).catch((res) => {
				tip(res.error);
			})
		},
		queryAddress() {
			this.$refs.addressPop.show();
			this.$refs.addressTable.query(this.queryParams).fetch();
		},
		showQRCode() {
			this.$refs.qrcodePop.show();
		},
		queryDeviceDetail() {
			this.$refs.devicePop.show();
			let url = apiPath.user.queryDeviceDetail;
			ajaxHttp(url, {
				"data": this.queryParams
			}).then((res) => {
				this.deviceDetail = res.data.deviceDetail;
			}).catch((res) => {
				tip(res.error);
			})
		},
		queryVertifyImage(index) {
			this.$refs.carimagePop.show();
			let url = apiPath.user.queryVertifyMessage;
			let queryParams = {
				id: this.vertifyInfos[index].id
			}
			ajaxHttp(url, {
				"data": queryParams
			}).then((res) => {
				this.vertiImageInfo = res.data;
			}).catch((res) => {
				tip(res.error);
			}); 
		},
		updateCarVertify(index, item) {
			this.vertifyIndex = index;
			this.vertifyItem = item;
			this.$refs.reasonInput.val('');
			if( item === -3 ) {
				this.$refs.vertifyPop.show();
				this.vertifyHead = "取消认证";
				this.vertifyTip = "请输入取消理由"
			} else if( item === -2 ) {
				this.$refs.vertifyPop.show();
				this.vertifyHead = "驳回";
				this.vertifyTip = "请输入驳回理由"
			} else if( item === 1 ) {
				this.changeVertifyState();
			}
		},
		changeVertifyState() {
			let url = apiPath.user.updateCarVertify;
			if(this.vertifyItem !== 1 && !this.$refs.reasonInput.val()) {
				tip("请输入理由！");
			} else {
				let inputLen = (this.$refs.reasonInput.val()).toString().length;
				if(inputLen > 120) {
          tip("输入内容不能超过120个字符！");
        } else {
        	let queryParams = {
						reason: this.$refs.reasonInput.val(),
						status: this.vertifyItem,
						id: this.vertifyInfos[this.vertifyIndex].id
					}
					ajaxHttp(url, {
						"type": "post",
						"data": queryParams
					}).then((res) => {
						this.vertifyInfos[this.vertifyIndex].vertifyState = res.data.vertifyState;
						this.vertifyInfos[this.vertifyIndex].reason = res.data.reason;
						if(this.vertifyItem === 1) {
							tip("已通过该认证！");
						} else if(this.vertifyItem === -2) {
							this.$refs.vertifyPop.hide();
							tip("已驳回该认证！");
						} else if(this.vertifyItem === -3) {
							this.$refs.vertifyPop.hide();
							tip("已取消该认证！");
						}
					}).catch((res) => {
						tip(res.error);
					}); 
        }
			}
		},
		showRejectReason(index) {
			this.$refs.rejectreasonPop.show();
			this.rejectReason = this.vertifyInfos[index].reason;
		},
		showStatePop(vm) {
			this.checkboxValue = vm;
			if(vm.queryName === "userFlag") {
				this.checkChangeTip = "确认修改该用户的身份标识？";
			} else if(vm.queryName === "forbitDay") {
				this.checkChangeTip = "确认修改社区禁言期限？";
			} else if(vm.queryName === "hideForum") {
				this.checkChangeTip = "确定对此用户进行隐藏全部帖子/点评的操作？";
			}
			this.$refs.savestatePop.show();
		},
		saveState() {
			let queryItem = this.checkboxValue.queryName;
			let url = "";
			let queryParams = {};
			if(queryItem === "userFlag") {
				url = apiPath.user.updateUserFlag;
				queryParams = {
					userId: this.$route.query.userId,
					userFlag: this.checkboxValue.value
				};
				ajaxHttp(url, {
					"type": "post",
					"data": queryParams
				}).then((res) => {
					this.$refs.flagCheckbox.val(res.data.userFlag);
					this.$refs.savestatePop.hide();
					tip("已成功修改用户的身份标识！");
				}).catch((res) => {
					tip(res.error);
				});
			} else if(queryItem === "forbitDay") {
				url = apiPath.user.setForbitDay;
				queryParams = {
					userId: this.$route.query.userId,
					forbitDay: this.checkboxValue.value
				};
				ajaxHttp(url, {
					"type": "post",
					"data": queryParams
				}).then((res) => {
					this.$refs.forbitCheckbox.val(res.data.forbitDay);
					this.form.forbitDay = res.data.forbitDay;
					this.form.noforbitDay = res.data.noforbitDay;
					this.$refs.savestatePop.hide();
					tip("已成功修改社区禁言期限！");
				}).catch((res) => {
					tip(res.error);
				});
			} else if(queryItem === "hideForum") {
				url = apiPath.user.setHideForum;
				queryParams = {
					userId: this.$route.query.userId,
					hideForumType: this.checkboxValue.value
				};
				ajaxHttp(url, {
					"type": "post",
					"data": queryParams
				}).then((res) => {
					this.$refs.hideCheckbox.val(res.data.hideForumType);
					this.$refs.savestatePop.hide();
					tip("已成功修改社区信息隐藏情况！");
				}).catch((res) => {
					tip(res.error);
				});
			}
		},
		cancelState() {
			if(this.checkboxValue.queryName === "userFlag") {
				this.$refs.flagCheckbox.val(this.checkboxValue.oldValue);
			} else if(this.checkboxValue.queryName === "forbitDay") {
				if(this.checkboxValue.oldValue) {
					this.$refs.forbitCheckbox.val(this.checkboxValue.oldValue);
				} else {
					this.$refs.forbitCheckbox.val(0);
				}
			} else if(this.checkboxValue.queryName === "hideForum") {
				this.$refs.hideCheckbox.val(this.checkboxValue.oldValue);
			}
			this.$refs.savestatePop.hide();
		},
		canForbitDay() {
			this.$refs.forbitCheckbox.val("");
			let url = apiPath.user.setForbitDay;
			let	queryParams = {
				userId: this.$route.query.userId,
				forbitDay: 0
			};
			ajaxHttp(url, {
				"type": "post",
				"data": queryParams
			}).then((res) => {
				this.$refs.forbitCheckbox.val(res.data.forbitDay);
				this.form.forbitDay = res.data.forbitDay;
				this.form.noforbitDay = res.data.noforbitDay;
				tip("已取消该用户的社区禁言！");
			}).catch((res) => {
				tip(res.error);
			});
		}
	},

	filters: {
		changeVertify(value) {
			return this.vertifyState[value];
		},
		changeSex(value) {
			return this.sex[value];
		},
		checkEmpty(value) {
			if(!value) {
				value = "--";
			}
			return value;
		}
	}
}

module.exports = UserDetail;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/user/user-detail/user-detail.js